// extracted by mini-css-extract-plugin
module.exports = {"tabPanelContent":"TemplateTabs_tabPanelContent__1G70Y"};